export default "__VITE_ASSET__59fa234e__"